/* This file was auto generated by "illustrations-tool" */
import { DEV } from 'esm-env';
import createSvgIllustration from '../createSvgIllustration';
export default createSvgIllustration(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={175}
    height={130}
    fill="none"
    viewBox="0 0 175 130"
  >
    <path
      fill="#C4D4FD"
      d="m121.1 91.4-12.7-22.1-15.6-27q-.6-.8-1.2 0L75.9 69.4l-15.6 27q-.3.9.6 1h56.7a4 4 0 0 0 3.5-6M89 86.6h-3v-4.4h3zm0-9.1h-3V59.9h3z"
      className="bg"
    />
    <path
      fill="#2A64F6"
      fillRule="evenodd"
      d="M53.4 105.9h68.2c3.7 0 7.1-1.9 9-5.2s1.9-7.2 0-10.4l-34.1-59a10.4 10.4 0 0 0-18 0l-34.1 59a10 10 0 0 0 0 10.4c1.9 3.3 5.3 5.2 9 5.2m-6.4-14 34.1-59a7 7 0 0 1 6.4-3.7q4.3.1 6.4 3.7l34.1 59a7.4 7.4 0 0 1-6.4 11.1H53.4a7 7 0 0 1-6.4-3.7 8 8 0 0 1 0-7.4m10.9 4.5h59.2q1.7 0 2.7-1.6a3 3 0 0 0 0-3.2L90.2 40.4a3 3 0 0 0-2.7-1.6q-1.7 0-2.7 1.6L55.2 91.6a3 3 0 0 0 0 3.2 3 3 0 0 0 2.7 1.6M87.4 42l.1-.1.1.1 29.5 51.2v.2l-.1.1H57.9l-.1-.1v-.2z"
      className="fg"
      clipRule="evenodd"
    />
  </svg>,
  DEV ? 'AttentionIllustration' : '',
);
